import React, { memo, useCallback } from "react";
import { PushPin, PushPinOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";

import { Account } from "fond/types";

interface PinCellRendererProps extends ICellRendererParams<Account> {
  isPinned: (id?: string) => boolean;
  onTogglePin: (account: Account) => void;
}

const PinCellRenderer: React.FC<PinCellRendererProps> = memo(({ data, isPinned, onTogglePin }: PinCellRendererProps) => {
  const pinned = isPinned(data?.ID);

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      if (data) {
        onTogglePin(data);
      }
    },
    [data, onTogglePin]
  );

  if (!data) return null;

  return (
    <Tooltip title={pinned ? "Unpin account" : "Pin account"}>
      <IconButton size="small" onClick={handleClick} data-testid={`pin-button-${data.ID}`}>
        {pinned ? <PushPin fontSize="small" color="primary" /> : <PushPinOutlined fontSize="small" color="action" />}
      </IconButton>
    </Tooltip>
  );
});

PinCellRenderer.displayName = "PinCellRenderer";

export default PinCellRenderer;
